var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('router-view'),(_vm.showUpdateDiv)?_c('div',{staticClass:"show",attrs:{"id":"snackbar"}},[_c('a',{attrs:{"id":"reload","href":""},on:{"click":function($event){return _vm.reload()}}},[_vm._v(_vm._s(_vm.$t('layout.newVersion')))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }